import { render, staticRenderFns } from "./NewEditBasic.vue?vue&type=template&id=3cd5ace6&"
import script from "../../models/shop-manage/new-edit-basic.ts?vue&type=script&lang=ts&"
export * from "../../models/shop-manage/new-edit-basic.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports